// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MyAccount: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                d="M8,3.5 C6.48124981,3.5 5.25,4.73124981 5.25,6.25 C5.25,7.76875019 6.48124981,9 8,9 C9.51875019,9 10.75,7.76875019 10.75,6.25 C10.75,4.73124981 9.51875019,3.5 8,3.5 Z M8,7.5 C7.31062508,7.5 6.75,6.9390626 6.75,6.25 C6.75,5.55937481 7.30937481,5 8,5 C8.69062519,5 9.25,5.56062508 9.25,6.25 C9.25,6.94062519 8.69062519,7.5 8,7.5 Z M8,0 C3.58125019,0 0,3.58125019 0,8 C0,12.4187498 3.58125019,16 8,16 C12.4187498,16 16,12.4187498 16,8 C16,3.58125019 12.4187498,0 8,0 Z M8,14.5 C6.53968763,14.5 5.19499969,14.0100002 4.109375,13.1940622 C4.6500001,12.15625 5.69999981,11.5 6.8812499,11.5 L9.12156296,11.5 C10.3012505,11.5 11.3500004,12.1565628 11.8928127,13.1940622 C10.8062496,14.0093746 9.45937538,14.5 8,14.5 Z M13.0062504,12.140625 C12.1625004,10.8218746 10.7250004,10 9.11874962,10 L6.8812499,10 C5.27624989,10 3.83906221,10.8203125 2.99374962,12.1400003 C2.06124973,11.015625 1.49999952,9.57187462 1.49999952,8 C1.49999952,4.41562462 4.41593695,1.5 7.99999952,1.5 C11.5840621,1.5 14.4999995,4.41593742 14.4999995,8 C14.4999995,9.57187462 13.9374995,11.015625 13.0062499,12.140625 L13.0062504,12.140625 Z"
            />
        </svg>
    );
};

export default React.memo(MyAccount);
